class messageConst {
    CONFIRM_REGIST = "登録します。よろしいですか？";
    CONFIRM_DELETE = "削除します。よろしいですか？";
    CONFIRM_SAVE_FAVORITE = "検索条件をお気に入りに登録しますか？";
    SUCCESS_REGIST = "登録完了しました。";
    SUCCESS_DELETE = "削除完了しました。";

    INPUT_ERROR = "※不正な項目が入力されています。内容を確認してください。";
    DESTINATION_ERROR = "※対象エリア・国・都市を選択してください。";
    HUMAN_NUM_ERROR = "※1室の上限人数は20人となります。20人以下にしてください。";
    EXIST_ERROR = "※入力された$targetは既に使用されています。";
    KEYWORD_ERROR = "※ひらがな、カタカナ、アルファベット、数字、記号は2文字以上のキーワードを指定してください。";
    NOT_SAVED_SEARCH = "※検索条件が保存されていません。";
    REPRESENT_ERROR = "※代表者が選択されていません。";
    CONDITION_ERROR = "※お申し込みに関する条件に同意してください。";
    ADULT_ERROR = "※各お部屋の代表者の方は、チェックイン日時点で21歳以上である必要があります。";
    RESERVE_ERROR = "※予約に失敗しました。";
    CANCEL_ERROR = "※予約のキャンセルに失敗しました。";
    PLAN_NOT_FOUND_ERROR = "※一致するプランが０件です。";

    SELECT_RECOMMEND = "選択したホテルのエリア・国・都市情報を反映しました。";
    CANCEL_DESCRIPTION_MESSAGE = "【現地時間表示となります。ご注意ください】"

    CONFIRM_MESSAGE = "下記の内容でよろしければ「この内容で予約する」ボタンを、\n訂正したい場合は「戻る」ボタンを押してください。";
    CONFIRM_MESSAGE_SP = "下記の内容でよろしければ\n「この内容で予約する」ボタンを、訂正したい場合は\n「戻る」ボタンを押してください。";
    CONFIRM_GOLF = "キャンセルされたプランのゴルフが予約されています。\nゴルフのキャンセルを行いますか？";
}


export default new messageConst();